import { Grid, makeStyles, Typography } from '@material-ui/core';

import IntegerInput from './integerInputBase';

import { DefaultPointsProps } from './PointsInputs';

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 10,
  },
}));

export const IntegerList: React.FC<DefaultPointsProps> = ({ onChange, point, value }) => {
  const classes = useStyles();

  const values = value.toString(2).padStart(16, '0').split('').reverse();

  const meanings = Object.entries(point.entry.meanings || {});
  const onKeyChange = (key: string, newValue: number) => {
    const indexStart = Number(key.split('-')[0]) || 0;
    const indexEnd = Number(key.split('-')[1]) || indexStart + 1;
    const length = indexEnd - indexStart + 1;

    const newValueBinary = (newValue || 0).toString(2).padStart(length, '0').split('');
    const newValues = [...values];
    newValues.splice(indexStart, length, ...newValueBinary.reverse());

    onChange(point, parseInt(newValues.reverse().join(''), 2));
  };

  return (
    <Grid container item className={classes.container} spacing={2}>
      {meanings.map(([key, label]) => {
        const indexStart = Number(key.split('-')[0]) || 0;
        const indexEnd = Number(key.split('-')[1]) || indexStart + 1;
        const binaryValue = values
          .slice(indexStart, indexEnd + 1)
          .reverse()
          .join('');
        const decimalValue = parseInt(binaryValue, 2);
        return (
          <Grid container item key={key} spacing={1} alignItems="center">
            <Grid item xs>
              <IntegerInput
                unit={point.unit}
                onKeyChange={onKeyChange}
                keyData={key}
                point={point}
                value={decimalValue}
              />
            </Grid>
            <Grid item xs>
              <Typography variant="body2">{label}</Typography>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};
